import { render, staticRenderFns } from "./ProviderReviewItem.vue?vue&type=template&id=d9aff176&"
import script from "./ProviderReviewItem.vue?vue&type=script&lang=js&"
export * from "./ProviderReviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports